
// const hideValues = false

import ApiService from './ApiService'

class AdminService {




    getGlobalAdmins = async (apiToken) => {
        let url = '/admin/global-admins'

        let params = {}
        let options = {}
        var result = null

        try {
            result = await ApiService.get(apiToken, url, params, options)
        } catch (err) {
            console.error(err)
        }
        return result
    }
  
    doWondeGlobalSync = async (apiToken, promptData) => {
        let url = '/admin/wonde/sync/all'

        let params = {}
        let body = { }

        try {
            var response = await ApiService.post(apiToken, url, params, body)
        } catch (err) {
            console.error(err)
            return {
                error: 'Error updating prompt: ' + err.message
            }
        }
        return response
    }

    doWondeSchoolSync = async (apiToken, orgId) => {
        let url = `/admin/wonde/sync/${orgId}`

        let params = {}
        let body = { }

        try {
            var response = await ApiService.post(apiToken, url, params, body)
        } catch (err) {
            console.error(err)
            return {
                error: 'Error syncing with Wonde: ' + err.message
            }
        }
        return response
    }

    doCpomsSchoolSync = async (apiToken, orgId) => {
        let url = `/admin/cpoms/sync/${orgId}`

        let params = {}
        let body = { }

        try {
            var response = await ApiService.post(apiToken, url, params, body)
        } catch (err) {
            console.error(err)
            return {
                error: 'Error syncing with Cpoms: ' + err.message
            }
        }
        return response
    }

}
export default new AdminService()

